/**
 * AI供应商管理API服务
 */
import { request } from '@/api/client'
import { API_ENDPOINTS as apiEndpoints } from '@/api/endpoints'

const ADMIN_PREFIX = '/api/v1/admin'

export interface AIProvider {
  id: number
  name: string  // 与后端数据库模型字段一致
  provider_name?: string  // 保持向后兼容
  model_name: string
  api_key?: string
  is_active: boolean
  input_cost_per_million: number
  output_cost_per_million: number
  cost_currency: string
  [key: string]: any
}

export const aiProvidersApi = {
  /**
   * 获取供应商列表
   */
  getList() {
    return request.get(apiEndpoints.aiProviders.list)
  },

  /**
   * 获取供应商详情
   */
  getDetail(id: number) {
    return request.get(apiEndpoints.aiProviders.detail(id))
  },

  /**
   * 创建供应商
   */
  create(data: Partial<AIProvider>) {
    return request.post(apiEndpoints.aiProviders.create, data)
  },

  /**
   * 更新供应商
   */
  update(id: number, data: Partial<AIProvider>) {
    return request.put(apiEndpoints.aiProviders.update(id), data)
  },

  /**
   * 删除供应商
   */
  delete(id: number) {
    return request.delete(apiEndpoints.aiProviders.delete(id))
  },

  /**
   * 切换默认供应商状态
   */
  toggleDefault(id: number) {
    return request.patch(`${ADMIN_PREFIX}/ai-providers/${id}/toggle-default`)
  },

  /**
   * 测试供应商连接
   * 后端 TestRequest 的字段是 test_message；旧版发的 test_prompt 会被忽略，自定义消息不生效
   */
  test(id: number, testPrompt?: string) {
    return request.post(apiEndpoints.aiProviders.test(id), { test_message: testPrompt })
  },

  /**
   * 测试流式响应
   */
  testStream(id: number) {
    return apiEndpoints.aiProviders.testStream(id)
  },

  /**
   * 获取价格信息
   */
  fetchPrice(modelName: string, providerName: string) {
    return request.post(apiEndpoints.aiProviders.fetchPrice, {
      model_name: modelName,
      provider_name: providerName
    })
  }
}